__turbopack_context__.v({
  "activeCategoryLink": "schemes-page-module__ngeWqq__activeCategoryLink",
  "ajaxSchemesList": "schemes-page-module__ngeWqq__ajaxSchemesList",
  "blur": "schemes-page-module__ngeWqq__blur",
  "categoriesList": "schemes-page-module__ngeWqq__categoriesList",
  "categoryLink": "schemes-page-module__ngeWqq__categoryLink",
  "contentContainer": "schemes-page-module__ngeWqq__contentContainer",
  "entryHeader": "schemes-page-module__ngeWqq__entryHeader",
  "entryTitle": "schemes-page-module__ngeWqq__entryTitle",
  "introInfo": "schemes-page-module__ngeWqq__introInfo",
  "loader": "schemes-page-module__ngeWqq__loader",
  "loaderContainer": "schemes-page-module__ngeWqq__loaderContainer",
  "postCard": "schemes-page-module__ngeWqq__postCard",
  "postCardImage": "schemes-page-module__ngeWqq__postCardImage",
  "postsList": "schemes-page-module__ngeWqq__postsList",
  "schemesPageDesc": "schemes-page-module__ngeWqq__schemesPageDesc",
  "schemesPageTitle": "schemes-page-module__ngeWqq__schemesPageTitle",
  "scrollToSchemes": "schemes-page-module__ngeWqq__scrollToSchemes",
  "shortDesc": "schemes-page-module__ngeWqq__shortDesc",
  "spin": "schemes-page-module__ngeWqq__spin",
  "visible": "schemes-page-module__ngeWqq__visible",
});
